<template>
    <div>
        <PageDocumentFormDebug v-bind:config="config" v-bind:contract-data="contractData" v-bind:formresult="formresult" v-on:loaded="debugLoaded" @debugbuildershowhide="onDebugBuilderShowHide" v-on:submissionchanged="submissionChanged" v-bind:submission="submission" v-bind:current-contract-id="currentContractId()" ref="debug"></PageDocumentFormDebug>

        <b-alert v-if="estrasfCredsInvalid" show variant="warning">
            <strong>Credenziali ESTRA SF</strong> —
            <span v-if="!estrasfCreds.found">non hai ancora configurato le tue credenziali del portale ESTRA SF.</span>
            <span v-else>le tue credenziali del portale ESTRA SF non risultano valide (password errata o scaduta).</span>
            Senza credenziali valide il contratto non potrà essere inviato.
            <router-link :to="{name:'setting-estrasf-credentials'}">Vai alla configurazione</router-link>
        </b-alert>

        <!-- ESTRA SF credentials block on submit -->
        <b-modal v-model="showEstrasfBlockModal" title="Credenziali ESTRA SF non valide" ok-only ok-title="Ho capito" centered>
            <p v-if="estrasfCreds && !estrasfCreds.found">
                Non hai ancora configurato le tue credenziali del portale ESTRA SF.
            </p>
            <p v-else>
                Le tue credenziali del portale ESTRA SF non risultano valide (password errata o scaduta).
            </p>
            <p>Per inviare questo contratto devi prima sistemare la login del portale ESTRA SF nel pannello dedicato.</p>
            <p>Nel frattempo puoi <strong>salvare in bozza</strong> e riprendere l'invio più tardi, una volta sistemate le credenziali.</p>
            <router-link :to="{name:'setting-estrasf-credentials'}" target="_blank" rel="noopener">Vai alla configurazione delle credenziali ESTRA SF</router-link>
        </b-modal>

        <KTPortlet
                v-bind="{
            }"
                v-bind:class="{ 'kt-spinner-f': loading }"
        >
            <template v-slot:title>
                <h4 class="">{{ isNew() ? 'Nuovo contratto':'Visualizza contratto' }} {{label}}</h4>
                <div class="copy-code" v-if="randomCode">
                    <input type="text" v-model="randomCode">
                    <button type="button" @click="doCopy"><i class="flaticon2-clip-symbol"></i></button>
                </div>
                <b-button v-if="submission.generaldata && enableDuplicate && createdToday" style="height: 27px;line-height: 9px;margin: -6px 4px 0 4px;" :to="{name:'document-submission-copy', params:{'id':currentContractId(),'csid':currentSubmissionId()}}" class="mr-2 btn-primary">Duplica</b-button>
                <b-button v-if="isDraft && submission.generaldata" @click="openTransferModal" style="height: 27px;line-height: 9px;margin: -6px 4px 0 4px;color: white;" class="mr-2 btn-info">Trasferisci</b-button>
                <template v-if="config.options.readOnly && submission.data">
                  <input @change="onFileChange" id="fileUpload" type="file"
                         hidden>
                  <b-button v-on:click="fileUpload" style="height: 27px;line-height: 9px;margin: -6px 4px 0 4px; white-space: nowrap;" class="mr-2 btn-primary">Allega file</b-button>
                </template>
                <template v-if="!config.options.readOnly && shouldSeeFillByFile()">
                  <div style="position: relative; display: inline-block; margin-left: 10px;">
                    <button
                      type="button"
                      @click="toggleUploadBox"
                      :disabled="uploadingPrefill"
                      v-b-tooltip.hover
                      :title="uploadingPrefill ? 'Elaborazione in corso...' : 'Carica un file per precompilare i campi del modulo'"
                      style="height: 27px; width: 27px; padding: 0; border: none; background: #5867dd; color: white; border-radius: 3px; cursor: pointer;"
                      :style="{ opacity: uploadingPrefill ? 0.6 : 1, cursor: uploadingPrefill ? 'not-allowed' : 'pointer' }">
                      <i v-if="!uploadingPrefill" class="flaticon2-file"></i>
                      <i v-else class="fa fa-spinner fa-spin"></i>
                    </button>
                    <span v-if="uploadingPrefill" style="margin-left: 8px; font-size: 12px; color: #5867dd; white-space: nowrap;">In elaborazione...</span>
                    <span v-if="fillingPrefill" style="margin-left: 8px; font-size: 12px; color: #5867dd; white-space: nowrap;">Compilazione in corso...</span>
                    <div v-if="showUploadBox && !uploadingPrefill" class="upload-box" @click.stop>
                      <div style="padding: 15px;">
                        <h5 style="margin: 0 0 10px 0;">Carica documento</h5>
                        <div style="margin-bottom: 15px;">
<!--                          <label style="display: block; margin-bottom: 5px;">Tipo documento:</label>-->
                          <select v-show="false" v-model="uploadDocType" class="form-control" style="width: 100%;">
<!--                            <option value="bolletta">Bolletta</option>-->
                            <option value="generic document">Documento generico</option>
                          </select>
                        </div>
                        <div
                          class="upload-dropzone"
                          @click="triggerPrefillFileUpload"
                          @dragover.prevent="onDragOver"
                          @dragleave.prevent="onDragLeave"
                          @drop.prevent="onDrop"
                          :class="{ 'dragover': isDragOver }">
                          <i class="flaticon2-cloud-upload" style="font-size: 32px; color: #999;"></i>
                          <p style="margin: 10px 0 0 0;">Trascina un file qui o clicca per selezionare</p>
                          <input
                            @change="onPrefillFileChange"
                            id="prefillFileUpload"
                            type="file"
                            ref="prefillFileInput"
                            hidden>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <div v-if="submission.generaldata && enableDuplicate && config.extraconfigParsed && config.extraconfigParsed.recopy && config.extraconfigParsed.recopy.length">
                  <template v-for="(item, i) in config.extraconfigParsed.recopy">
                    <b-button style="height: 27px;line-height: 9px;margin: -6px 0 0 0;" :to="{name:'document-submission-recopy', params:{'id':item.contract_id,'csid':currentSubmissionId()}}" class="mr-2 btn-primary">Copia in {{item.contract_name}}</b-button>
                  </template>
                </div>
                <div v-if="attachments && attachments.length > 0" v-bind:class="{ 'kt-spinner-f': attachmentsLoading }">
                  <span style="margin:0 2px">Allegati:</span>
                  <template v-for="(item, i) in attachments">
                    <b-button style="height: 27px;line-height: 9px;margin: -6px 0 0 0;" @click="getSubmissionAttachment(item)" class="mr-2 btn-secondary">{{item.Name}}</b-button>
                  </template>
                </div>
            </template>
            <template v-slot:body>
                <!--                                <app-customform v-if="config" v-bind:configinput="JSON.stringify(config)"></app-customform>-->
                <formio v-bind:class="{ 'formio-readonly': config.options.readOnly }" id="formfinal" ref="formfinal"
                        v-on:render="onRender"
                        v-on:prevPage="onPrevPage"
                        v-on:nextPage="onNextPage"
                        v-bind:url="config.formurl" v-if="config.form && loadedDebug && loadedQuery && !loadingSubmission && !debugBuilderShowHide"
                        v-bind:form="config['form']" v-bind:submission="submission" v-bind:options="config['options']"
                        v-on:change="onFormChange" readOnly="config.options.readOnly"
                        language="it"></formio>
                <div v-if="featureDraftEnabled && !config.options.readOnly && submission.data && loadedDebug" style="text-align: right">
                    <button @click="saveDraft" style="width: fit-content" class="btn btn-warning">Salva bozza</button>
                </div>

            </template>
        </KTPortlet>

        <KTPortlet
                v-bind="{
            }"
                v-if="submission.generaldata"
                v-bind:class="{ 'kt-spinner-f': loading }"
        >
            <template v-slot:title>
                <h4 class="">{{ 'Informazioni' }}</h4>
            </template>
            <template v-slot:body>
              <div class="row">
                <div class="col-xl-4 col-lg-12">
                  <table class="table-info" style="table-layout: fixed">
                      <tbody>
                      <tr v-if="submission.generaldata.status">
                          <td>STATO</td>
                          <td>{{submission.generaldata.status}}</td>
                      </tr>
                      <tr v-if="submission.generaldata.created_at">
                          <td>Data creazione</td>
                          <td>{{submission.generaldata.created_at | formatDate}}</td>
                      </tr>
                      <tr v-if="submission.generaldata.sent_at">
                          <td>Data invio</td>
                          <td>{{submission.generaldata.sent_at | formatDate}}</td>
                      </tr>
                      <tr v-if="submission.generaldata.expires_at">
                          <td>Data scadenza</td>
                          <td>{{submission.generaldata.expires_at | formatDate}}</td>
                      </tr>
                      <tr v-if="submission.generaldata.signed_at">
                          <td>Data firma</td>
                          <td>{{submission.generaldata.signed_at | formatDate}}</td>
                      </tr>
                      <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.status">
                          <td>Stato Instant Call</td>
                          <td>{{submission.generaldata.instantCallJob.status}}</td>
                      </tr>
                      <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.note">
                          <td>Dettaglio Stato Instant</td>
                          <td>{{submission.generaldata.instantCallJob.note}}</td>
                      </tr>
                      <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.sent_at">
                          <td>Data invio Instant Call</td>
                          <td>{{submission.generaldata.instantCallJob.sent_at | formatDate}}</td>
                      </tr>
                      <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.callback_at">
                          <td>Data Callback Instant Call</td>
                          <td>{{submission.generaldata.instantCallJob.callback_at | formatDate}}</td>
                      </tr>
                      <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.eva_status">
                          <td>Stato CRM</td>
                          <td>{{submission.generaldata.instantCallJob.eva_status}}</td>
                      </tr>
                      <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.eva_sent_at">
                          <td>Data invio a CRM</td>
                          <td>{{submission.generaldata.instantCallJob.eva_sent_at | formatDate}}</td>
                      </tr>
                      <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.eva_error ">
                          <td>Errore CRM</td>
                          <td>{{submission.generaldata.instantCallJob.eva_error}}</td>
                      </tr>
                      <tr v-if="submission.generaldata.ext_status">
                          <td>External Status</td>
                          <td>{{submission.generaldata.ext_status}}</td>
                      </tr>
                      <tr v-if="submission.generaldata.ext_status_description">
                          <td>External Status Description</td>
                          <td>{{submission.generaldata.ext_status_description}}</td>
                      </tr>
                      </tbody>
                  </table>
                </div>
                <div class="col-xl-8 col-lg-12" v-if="submission.generaldata && showLoadHistory()">
                  <FormDocumentHistorySummary :submission-id="currentSubmissionId()" />
                </div>
                <div class="col-md-6 col-sm-12">


                  <div id="mapsub" v-if="hasMap()" style="width: 500px; height: 400px;"></div>


                </div>
              </div>
            </template>
        </KTPortlet>

        <!-- Transfer Draft Modal -->
        <b-modal v-model="showTransferModal" title="Trasferisci bozza" @ok="transferDraft" @hidden="closeTransferModal" :ok-disabled="!selectedUserId || transferLoading" size="lg">
            <div v-if="transferLoading" class="text-center">
                <b-spinner variant="primary"></b-spinner>
                <p class="mt-2">Trasferimento in corso...</p>
            </div>
            <div v-else>
                <p>Seleziona l'utente a cui trasferire questa bozza:</p>

                <!-- Search input -->
                <b-form-group label="Cerca utente:">
                    <b-form-input
                        v-model="userSearchQuery"
                        placeholder="Cerca per nome, cognome o email..."
                        :disabled="loadingUsers"
                        @input="filterUsers">
                    </b-form-input>
                </b-form-group>

                <!-- User selection list -->
                <b-form-group label="Utente destinatario:" v-if="!loadingUsers">
                    <div style="max-height: 300px; overflow-y: auto; border: 1px solid #ced4da; border-radius: 0.25rem;">
                        <b-list-group>
                            <b-list-group-item
                                v-for="user in filteredUsersOptions"
                                :key="user.value"
                                :active="selectedUserId === user.value"
                                @click="selectedUserId = user.value"
                                button
                                class="d-flex justify-content-between align-items-center">
                                <div>
                                    <strong>{{ user.firstname }} {{ user.lastname }}</strong>
                                    <br>
                                    <small class="text-muted">{{ user.email }}</small>
                                </div>
                                <b-badge v-if="selectedUserId === user.value" variant="primary">Selezionato</b-badge>
                            </b-list-group-item>
                            <b-list-group-item v-if="filteredUsersOptions.length === 0" class="text-center text-muted">
                                Nessun utente trovato
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                </b-form-group>

                <div v-if="loadingUsers" class="text-center">
                    <b-spinner small variant="primary"></b-spinner>
                    <span class="ml-2">Caricamento utenti...</span>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<style>
    #formfinal .pagination {
        display: block;
        list-style-type: none;
    }

    #formfinal .pagination .page-item {
        display: inline-block;
        cursor: pointer;
    }

    #formfinal .alert ul {
        display: block;
        margin: 27px 0;
    }

    #formfinal .maxwidth500 {
        max-width: 500px;
        margin: 0 auto;
    }

    .formio-day-component-day {
        width: 100%;
    }


    .formio-form ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #ddd;
    }

    .formio-form :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #ddd;
    }

    .formio-form ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #ddd;
    }

    .formio-form :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #ddd;
    }

    .formio-form input::placeholder {
        color: #ddd;
    }

    .formio-form textarea::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #ddd;
    }

    .formio-form textarea:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #ddd;
    }

    .formio-form textarea::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #ddd;
    }

    .formio-form textarea:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #ddd;
    }

    .formio-form textarea::placeholder {
        color: #ddd;
    }

    .formio-readonly ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: transparent;
    }

    .formio-readonly :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: transparent;
    }

    .formio-readonly ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: transparent;
    }

    .formio-readonly :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: transparent;
    }

    .formio-readonly input::placeholder {
        color: transparent;
    }

    .formio-readonly textarea::-webkit-input-placeholder {
        /* WebKit browsers */
        color: transparent;
    }

    .formio-readonly textarea:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: transparent;
    }

    .formio-readonly textarea::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: transparent;
    }

    .formio-readonly textarea:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: transparent;
    }

    .formio-readonly textarea::placeholder {
        color: transparent;
    }



    .form-test textarea {
        min-height: 300px;
    }


    .copy-code {
        margin: -7px 50px 0;
        border: 1px solid #ccc;
        padding: 4px;
    }

    .copy-code input {
        width: 100px;
    }

    .formio-select-autocomplete-input {
        /* we can't use display: none or visibility: hidden because autocomplete won't work on hidden field */
        /* https://github.com/formio/formio.js/commit/e0b2e3a671aeacad503d0ae25d79d204d3d68bfb */
        display:none !important;
        visibility: hidden !important;
    }

    .upload-box {
        position: absolute;
        top: 35px;
        right: 0;
        background: white;
        border: 1px solid #ccc;
        border-radius: 5px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        min-width: 350px;
        z-index: 1000;
    }

    .upload-dropzone {
        border: 2px dashed #ccc;
        border-radius: 5px;
        padding: 30px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s;
    }

    .upload-dropzone:hover {
        border-color: #5867dd;
        background-color: #f8f9fa;
    }

    .upload-dropzone.dragover {
        border-color: #5867dd;
        background-color: #e7f3ff;
    }
</style>
<script>
    import {SET_BREADCRUMB} from "@/store/breadcrumbs.module";
    import KTPortlet from "@/views/partials/content/Portlet.vue";
    import {Components, Form, FormBuilder} from 'vue-formio'; // used by builder only
    import ApiService from "../../../common/api.service";
    import UserService from "../../../common/user.service";
    import PrefillService from "../../../common/form/prefill.service";
    import Vue from "vue";
    // import './../../../../public/assets/js/output-es5.js';
    // import temporaryform from "./temporaryform"; // TODO REMOVE
    // import temporaryformdata from "./temporaryformdata"; // TODO REMOVE
    import JwtService from "@/common/jwt.service";
    import $ from 'jquery';
    import VueClipboard from 'vue-clipboard2'
    import UtilService from "../../../common/util.service";
    import PageDocumentFormDebug from "../../partials/pages/document/form/Debug";
    import {API_URL, FEATURE_DRAFT_ENABLED} from "../../../common/config";
    // import {uniqueName} from 'formiojs/utils/utils';
    import { Formio } from "formiojs";
    import CrmService from "@/common/crm.service";
    import moment from "moment";
    import FormDocumentHistorySummary from "./FormDocumentHistorySummary.vue";

    export default {
        data() {
            return {
                currentFormData: null,
                estrasfCreds: null,
                showEstrasfBlockModal: false,
                enableDuplicate: false,
                featureDraftEnabled: FEATURE_DRAFT_ENABLED,
                contractData: null,
                createdToday: false,
                loading: false,
                label: null,
                randomCode: null,
                isDraft: false,
                contractId: null,
                formresult: null,
                loadedDebug: false,
                loadedQuery: false,
                attachments: null,
                attachmentsLoading: false,
                loadingSubmission: false,
                debugBuilderShowHide:false,
                originalContractLogId: false,
                originalContractUserId: false,
                originalDuplicatedId: false,
                showUploadBox: false,
                // uploadDocType: 'bolletta',
                uploadDocType: 'generic document',
                isDragOver: false,
                uploadingPrefill: false,
                fillingPrefill: false,
                showTransferModal: false,
                selectedUserId: null,
                availableUsers: [],
                filteredUsers: [],
                userSearchQuery: '',
                loadingUsers: false,
                transferLoading: false,
                submission: {
                    data: {},
                    generaldata: null
                },
                config: {
                    formbuilder: null,
                    formurl: Vue.axios.defaults.baseURL,
                    // windowCallbackFormBeforeSubmit:'extVueFormBeforeSubmit',
                    options: {
                        hooks: {
                            beforeSubmit: (submission, callback) => {
                            // submit: (submission, callback) => {
                              console.log('extVueFormBeforeSubmit received', submission, callback);
                              // if (!this.$refs.formfinal.formio.checkValidity(null, false, null, true)) {
                              if (!this.$refs.formfinal.formio.checkValidity(null, true, null, false)) {
                                console.log('not valid');
                              }else {
                                console.log('valid');
                                if (this.estrasfCredsInvalid) {
                                  this.showEstrasfBlockModal = true;
                                  callback('Credenziali ESTRA SF non valide: configura le tue credenziali del portale ESTRA SF prima di inviare il contratto.');
                                  return;
                                }
                                this.submit(submission, callback);
                              }
                            }
                        },
                        readOnly: false,
                        // base:Vue.axios.defaults.baseURL,
                        // project:Vue.axios.defaults.baseURL,
                        i18n: {
                            it: {
                                'alertMessage': '{{label}}: {{message}}',
                                'cancel': 'Annulla',
                                'previous': 'Precedente',
                                'Previous': 'Precedente',
                                'next': 'Successivo',
                                'Next': 'Successivo',
                                'Submit': 'Invia',
                                'submit': 'Invia',
                                'required': 'Richiesto',
                                'error': 'Errore',
                                'complete': 'Inviato',
                                'Type to search': 'Digita per cercare',
                                'Day': 'Giorno',
                                'Month': 'Mese',
                                'Year': 'Anno',
                                'January': 'Gennaio',
                                'February': 'Febbraio',
                                'March': 'Marzo',
                                'April': 'Aprile',
                                'May': 'Maggio',
                                'June': 'Giugno',
                                'July': 'Luglio',
                                'August': 'Agosto',
                                'September': 'Settembre',
                                'October': 'Ottobre',
                                'November': 'Novembre',
                                'December': 'Dicembre',
                            }
                        }
                    },
                    form: null,
                    formsubmit: null,
                    forminit: null,
                    extraconfig: null,
                    extraconfigParsed: null
                }
            }
        },
        components: {
            KTPortlet,
            formio: Form,
            PageDocumentFormDebug,
            FormDocumentHistorySummary
        },
        mounted() {


            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Documenti", route: "/document"},
                {title: "Contratto"}
            ]);

            Vue.use(VueClipboard);

            window.currentUserEmail = this.$store.getters.currentUser.email;
            window.currentUser = {
              id:this.$store.getters.currentUser.id,
              email:this.$store.getters.currentUser.email,
              firstname:this.$store.getters.currentUser.firstname,
              lastname:this.$store.getters.currentUser.lastname,
              fiscal_code:this.$store.getters.currentUser.fiscal_code,
            }


            // window['extVueFormBeforeSubmit'] = function(submission,callback){
            //     console.log('extVueFormBeforeSubmit received',submission,callback);
            //     // callback({
            //     //     message: "Something bad happened.",
            //     //     component: null
            //     // }, null);
            //     callback(null, submission);
            // };
            this.reload();


        },

        created() {
            this.isDraft = this.$route.name === 'document-draft-view';

            this.overrideFormioUploadFile();

        },

        computed: {
            estrasfCredsInvalid() {
                return !!(this.estrasfCreds && (!this.estrasfCreds.found || !this.estrasfCreds.valid));
            },
            filteredUsersOptions() {
                if (!this.userSearchQuery) {
                    return this.filteredUsers;
                }

                const query = this.userSearchQuery.toLowerCase();
                return this.filteredUsers.filter(user => {
                    const fullName = `${user.firstname} ${user.lastname}`.toLowerCase();
                    const email = user.email.toLowerCase();
                    return fullName.includes(query) || email.includes(query);
                });
            }
        },
        methods: {
		    shouldSeeFillByFile() {
                return this.$refs.debug.isSuperDebugUser() || (window.__env && window.__env.allowedOrganizationsFillFormByFile ? window.__env.allowedOrganizationsFillFormByFile : []).includes(this.$store.getters.currentUser.organization_id);
            },
            overrideFormioUploadFile: function(){
              /** Add current component information to global to allow file upload service to know which component is uploading */

              const FileComponent = (Formio).Components.components.file;
              class CustomFileComponent extends FileComponent {
                constructor(component, options, data) {
                  super(component, options, data);
                  this.currentcomponent = component;
                }
                upload(files) {
                  window.currentUploadComponent = this.currentcomponent;
                  super.upload(files);
                }

              }

              // Components.addComponent('CustomFileComponent',CustomFileComponent);
              (Formio).Components.components['file'] = CustomFileComponent;

            },
            showLoadHistory: function () {
              // only if current organization has history enabled
              return true;
            },
            doCopy: function () {
                this.$copyText(this.randomCode).then(function (e) {
                    // alert('Copied')
                    // console.log(e)
                }, function (e) {
                    // alert('Can not copy')
                    // console.log(e)
                })
            },
            checkEstrasfCredentials: function (formdata) {
                this.estrasfCreds = null;
                // Only while compiling (new contract or draft), and only for
                // ESTRA SF contracts — recognizable by their forminit
                // bootstrapping window.SolowebEstraSF (which also carries the
                // service base url once evaluated).
                if (this.config.options.readOnly) {
                    return;
                }
                if (!formdata || !formdata.forminit || formdata.forminit.indexOf('SolowebEstraSF') === -1) {
                    return;
                }
                const endpoint = ((window.SolowebEstraSF && window.SolowebEstraSF.baseUrl)
                    || (window.__env && window.__env.estrasfServiceUrl)
                    || 'https://estra-sf.dock.fastsign.it').replace(/\/+$/, '');
                const user = this.$store.getters.currentUser;
                fetch(endpoint + '/credentials/check?userId=' + encodeURIComponent(user.id) + '&userEmail=' + encodeURIComponent(user.email))
                    .then(r => r.ok ? r.json() : null)
                    .then(data => {
                        // ok:false means the lookup infra is down, not a creds
                        // problem — keep quiet in that case
                        if (data && data.ok) {
                            this.estrasfCreds = data;
                        }
                    })
                    .catch(() => {});
            },
            reload: function () {
                window.finalReData = null;
                this.loading = true;
                this.config.options.readOnly = !this.isNew() && !this.isDraft;
                let that = this;
                let promises = [
                    new Promise(resolve => {
                        ApiService.get('contracts/' + this.currentContractId())
                            .then(({data}) => {



                              ApiService.get('contracts')
                                  .then( data2  => {
                                    that.enableDuplicate = !!data2.data.rows.find((x) => x.id == that.currentContractId());
                                  })
                                  .catch(({ response }) => {
                                    //context.commit(SET_ERROR, response.data.errors);
                                  });




                                this.contractData = data;
                                this.label = data.contract.label;
                                //this.config.form = JSON.parse(data.contract.form);
                                let formdata = JSON.parse(data.contract.form);

                                //this.config.form = JSON.parse(JSON.stringify(temporaryform).replace(/BASEAPIURL/g,Vue.axios.defaults.baseURL));
                                // if(this.useDebugData()){
                                //     this.config.form = JSON.parse(JSON.stringify(temporaryform).replace(/MAINAPITOKEN/g, JwtService.getToken()));
                                //     this.submission.data = temporaryformdata;
                                // }else{
                                const formConfig = JSON.parse(JSON.stringify(formdata.form)
                                    .replace(/MAINAPITOKEN/g, JwtService.getToken())
                                    // .replace(/MAINAPIUPLOAD/g, '/form-upload?form=' + this.currentContractId())
                                );


                                const that = this;
                              class FastStorageProvider {

                                constructor(loader, fileService, component)
                                {
                                  console.log(loader,fileService);
                                  // window.uploadingFormFiles = [];
                                  this.component = component;
                                }

                                static get title() {
                                  return 'FastStorageProvider';
                                }


                                uploadFile(file, name, dir, progressCallback, url, options, fileKey, groupPermissions, groupId, abortCallback)  {
                                  const currentUploadComponent = window.currentUploadComponent;
                                  const hasNameTemplateSet = !!(currentUploadComponent && currentUploadComponent.fileNameTemplate);
                                  let fileName = hasNameTemplateSet?name:file.name;
                                  if(hasNameTemplateSet) {
                                    // remove guid, that is required by formio (interpolate)
                                    if (fileName.match(/-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/)) {
                                      // remove if matched
                                      fileName = fileName.replace(/-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/, '');
                                    }
                                  }

                                  return new Promise(async (resolve, reject) => {

                                    const arrayBuffer = await file.arrayBuffer();

                                    let binary = '';
                                    const bytes = new Uint8Array(arrayBuffer);
                                    const len = bytes.byteLength;
                                    for (let i = 0; i < len; i++) {
                                      binary += String.fromCharCode(bytes[i]);
                                    }

                                    const base64 = btoa(binary);

                                    // Keyed cache: store by component key (fileKey param = component key in formio)
                                    window._uploadedFilesCache = window._uploadedFilesCache || {};
                                    var cacheKey = (this.component && this.component.key) ? this.component.key : (fileKey || 'file');
                                    console.log('[FastStorageProvider] cached base64 for key:', cacheKey);
                                    window._uploadedFilesCache[cacheKey] = {
                                      base64: base64,
                                      fileName: fileName,
                                      fileType: file.type,
                                      fileSize: file.size
                                    };

                                    ApiService.post('submissions/upload?organization_id='+that.$store.getters.currentUser.organization_id, {
                                      'base64': base64,
                                      // 'contract_configuration_id': that.currentDocumentEditId(),
                                    })
                                        .then(({data}) => {
                                          // const fileName = uniqueName(file.name, this.component.fileNameTemplate, this.evalContext());
                                          // const escapedFileName = file.name ? file.name.replaceAll('<', '&lt;').replaceAll('>', '&gt;') : file.name;

                                          // Vue.customNotifySuccess('Salvato');
                                          const ret = {
                                            storage: 'FastStorageProvider',
                                            name: fileName,
                                            // originalUploadedName: file.name,
                                            // url: 'data:' + file.type + ';base64,' + base64,
                                            apiname: fileKey,
                                            fileKey: data.fileKey,
                                            size: file.size,
                                            type: file.type,
                                            // data: base64
                                          };

                                          resolve(ret);

                                        })
                                        .catch(({response}) => {
                                          //context.commit(SET_ERROR, response.data.errors);
                                          Vue.customNotifyError('Errore', response.data && response.data.errors ? response.data.errors.join(', ') : 'Si prega di riprovare');
                                        });

                                  });
                                }

                                deleteFile(fileInfo) {
                                  return new Promise((resolve, reject) => {
                                  });
                                }

                                downloadFile(file) {
                                  return new Promise((resolve, reject) => {
                                    let fileNameDownload = file.name;
                                    ApiService.getFile('submissions/download?organization_id='+that.$store.getters.currentUser.organization_id+'&fileKey='+encodeURIComponent(file.fileKey)+'&').then(({data}) => {
                                      var blob = new Blob([data], { type: 'application/octet-stream' });
                                      if (window.navigator.msSaveBlob) { // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
                                        // window.navigator.msSaveOrOpenBlob(blob, file.originalName);
                                        window.navigator.msSaveOrOpenBlob(blob, fileNameDownload);
                                      }
                                      else {
                                        var a = window.document.createElement("a");
                                        a.href = window.URL.createObjectURL(blob, { type: "application/octet-stream" });
                                        // a.download = file.originalName;
                                        a.download = fileNameDownload;
                                        document.body.appendChild(a);
                                        a.click();  // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
                                        document.body.removeChild(a);
                                      }

                                      resolve(false);
                                    })
                                        .catch(({response}) => {
                                          //context.commit(SET_ERROR, response.data.errors);
                                          Vue.customNotifyError('Errore', response);
                                        });
                                  });
                                }
                              }

                              window.customFastStorageProvider = new FastStorageProvider(); // needed for later download from topbar

                              if (Formio) {
                                // https://github.com/formio/angular/issues/384
                                // https://formio.github.io/formio.js/docs/file/src/providers/storage/s3.js.html
                                // https://formio.github.io/formio.js/docs/file/src/providers/storage/url.js.html
                                // Formio.providers.storage = { FastStorageProvider };
                                // https://help.form.io/developers/modules
                                Formio.Providers.addProvider('storage', 'FastStorageProvider', FastStorageProvider);
                              }

                                // window.see = formConfig;

                                this.config.form = formConfig;


                                // }
                                //
                                //
                                // window.formio = this.config['form']; //TODO can be removed

                                if (formdata.formsubmit) {
                                    this.config.formsubmit = formdata.formsubmit;

                                }
                                if (formdata.forminit) {
                                    this.config.forminit = formdata.forminit;
                                }
                                if (formdata.extraconfig) {
                                    this.config.extraconfig = formdata.extraconfig;
                                    //console.log('window.extraconfigParsed = '+formdata.extraconfig+';');
                                    try {
                                      eval('window.extraconfigParsed = ' + formdata.extraconfig + ';');
                                    }catch(eeee){

                                    }
                                    if(window.extraconfigParsed) {
                                      this.config.extraconfigParsed = window.extraconfigParsed;
                                    }
                                }
                                if (!this.currentSubmissionId() || this.isDraft) {
                                    if (this.config.forminit) {
                                        try {
                                            var submission = this.submission;
                                            eval(this.config.forminit);
                                        } catch (e) {
                                            console.warn(e);
                                        }
                                    }

                                }

                                this.checkEstrasfCredentials(formdata);

                                if (this.$refs.debug.isSuperDebugUser()) {
                                    //https://github.com/formio/formio.js/issues/2361
                                    setTimeout(function () {
                                        that.$refs.debug.loaded();
                                    }, 1)

                                    // this.$refs.formBuilder.buildForm(this.config.form);
                                }else{
                                    this.loadedDebug = true;
                                }


                                // Request geolocation permissions if needed
                                if(!this.config.options.readOnly) {
                                  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                                  const needsGeolocation = (this.config.extraconfigParsed && this.config.extraconfigParsed.geolocation) && isMobile;
                                  if(needsGeolocation) {
                                    this.getPositionData();
                                  }
                                }

                                // Fill data if any from query string (skip for recopy — data comes from the mapping)
                                if(this.$route.name !== 'document-submission-recopy') {
                                  this.loadedQuery = false;
                                  this.fillDataFromQueryString(this,this.submission.data).then((data)=>{
                                    this.submission.data = data;
                                    this.loadedQuery = true;
                                  });
                                }

                                // Finally resolve
                                resolve(data);
                            })
                            .catch(({response}) => {
                                console.log(response);
                                //context.commit(SET_ERROR, response.data.errors);
                            });
                    })
                ];
                const currentSubmissionOrDuplicateSubmissionId = this.currentSubmissionId() ? this.currentSubmissionId() : this.currentDuplicateSubmissionId();
                if (currentSubmissionOrDuplicateSubmissionId) {
                    promises.push(new Promise(resolve => {
                        ApiService.get((this.isDraft ? 'drafts/' : 'submissions/') + currentSubmissionOrDuplicateSubmissionId)
                            .then(({data}) => {

                                let parse = this.isDraft ? JSON.parse(data.data).data : JSON.parse(data.additional_info);
                                if(this.currentDuplicateSubmissionId()) {
                                  delete parse.submission.agent;
                                  delete parse.submission.agent_pwd;
                                  that.originalDuplicatedId = this.currentDuplicateSubmissionId();
                                }
                                if(!that.originalDuplicatedId && parse.original_duplicated_id){
                                  that.originalDuplicatedId = parse.original_duplicated_id;
                                }

                                // Extract ext_status and ext_status_description from additional_info
                                if(parse.ext_status) {
                                  data.ext_status = parse.ext_status;
                                }
                                if(parse.ext_status_description) {
                                  data.ext_status_description = parse.ext_status_description;
                                }

                                if(this.isDraft && parse.original_contract_log_id){
                                  that.originalContractLogId = parse.original_contract_log_id;
                                }
                                if(this.isDraft && parse.original_contract_user_id){
                                  that.originalContractUserId = parse.original_contract_user_id;
                                }

                              this.createdToday = data.created_at && new Date(data.created_at).toDateString() === new Date().toDateString();

                              //   data.geolocation = {
                              //   "id": 2,
                              //       "contract_log_id": 32,
                              //       "status": "PROCESSED",
                              //       "user_position": {
                              //     "latitude": 41.12313,
                              //         "longitude": 12.123132
                              //   },
                              //   "closest_position": {
                              //     "latitude": 42.12313,
                              //         "longitude": 13.123132,
                              //         "address": "via tuscolana 00173 Roma"
                              //   },
                              //   "distance": "1400.00",
                              //       "error_at": null,
                              //       "processed_at": "2023-02-16T09:26:51.000Z",
                              //       "created_at": "2023-02-16T09:19:54.000Z",
                              //       "updated_at": "2023-02-16T09:26:51.000Z"
                              // };




                                if(this.$route.name === 'document-submission-recopy'){
                                  // Get config from the source contract

                                  ApiService.get('contracts/' + data.contract_configuration_id)
                                      .then((datasource) => {
                                            let formdataSource = JSON.parse(datasource.data.contract.form);
                                            // const formConfigSource = JSON.parse(JSON.stringify(formdataSource.form).replace(/MAINAPITOKEN/g, JwtService.getToken()));
                                            if (formdataSource.extraconfig) {
                                              try {
                                                eval('window.extraconfigParsedSource = ' + formdataSource.extraconfig + ';');
                                              } catch (eeee) {

                                              }
                                              if (window.extraconfigParsedSource && window.extraconfigParsedSource.recopy) {
                                                var foundE = window.extraconfigParsedSource.recopy.find(x => x.contract_id == that.currentContractId());
                                                if(foundE && foundE.mapping){
                                                  var finalReData = foundE.mapping(parse.submission);
                                                  window.finalReData = finalReData;
                                                  this.submission.data = finalReData;
                                                  that.loadedQuery = true;
                                                  resolve(finalReData);
                                                  return;
                                                }
                                              }
                                            }
                                            // Fallback: mapping not found, use source submission as-is
                                            this.submission.data = parse.submission;
                                            that.loadedQuery = true;
                                            resolve(data);
                                      }
                                      );


                                }else {


                                  this.submission.data = parse.submission;

                                  if (!this.currentDuplicateSubmissionId()) { // If not cloning

                                    this.submission.generaldata = data;

                                    this.loadSubmissionAttachments();

                                    if (parse && parse.data && parse.data.codice_contratto) {
                                      this.randomCode = parse.data.codice_contratto;
                                    }

                                  }

                                  resolve(data);
                                }
                            })
                            .catch(({response}) => {
                                //context.commit(SET_ERROR, response.data.errors);
                            });
                    }));
                }
                Promise.all(
                    promises).then(() => {
                    // console.log('loaded');

                    if(this.config.options.readOnly ){
                      if(this.hasMap()) {
                        this.loadMapLocations();
                      }
                    }

                    if(window.finalReData) {
                      var reData = window.finalReData;
                      window.finalReData = null;
                      setTimeout(()=>{
                        this.submissionChanged(reData);
                      },10);
                    }

                    this.loading = false;
                });

                // Click to next button scroll to top
                $('body').on('click', '.btn-wizard-nav-next', null, function () {
                    $('html, body').animate({scrollTop: $('#formfinal').offset().top - 150}, 100);
                });
            },
            fillDataFromQueryString : function(that,data){
              return new Promise(async resolve => {
                const formconfig = that.config.form;

                let findComponentWithKey = (nestedObject, targetKey) => {


                  function traverse(obj) {
                    if (!obj || typeof obj !== 'object') return null;

                    // If the current object has the target key
                    // console.log(obj.key);
                    if (obj.key === targetKey) {
                      return obj;
                    }

                    // If the current object has a "components" child (which is an array)
                    if (Array.isArray(obj.components)) {
                      for (let component of obj.components) {
                        const found = traverse(component);
                        if (found) return found; // Return as soon as we find the first match
                      }
                    }
                    // If the current object has a "columns" child (which is an array)
                    if (Array.isArray(obj.columns)) {
                      for (let component of obj.columns) {
                        const found = traverse(component);
                        if (found) return found; // Return as soon as we find the first match
                      }
                    }

                    return null;
                  }

                  return traverse(nestedObject);
                };


                // Fill data if any from query string
                const query = new URLSearchParams(window.location.href.split('?')[1]);
                const queryformdata = {};
                for (var pair of query.entries()) {
                  var m = pair[0].match(/form\[(.*?)\]/);
                  if (m) {
                    queryformdata[m[1]] = pair[1];
                  }
                }
                const queryformsuggestfielddata = {};
                for (var pair of query.entries()) {
                  var m = pair[0].match(/formsuggestfield\[(.*?)\]/);
                  if (m) {
                    queryformsuggestfielddata[m[1]] = pair[1];
                  }
                }
                const queryformsuggestfieldvaluedata = {};
                for (var pair of query.entries()) {
                  var m = pair[0].match(/formsuggestfieldvalue\[(.*?)\]/);
                  if (m) {
                    queryformsuggestfieldvaluedata[m[1]] = pair[1];
                  }
                }
                //foreach queryformdata assign to data
                var promises = [];
                for (const [key, value] of Object.entries(queryformdata)) {
                  if (queryformsuggestfielddata[key]) {
                    // contact api if present
                    promises.push(()=>new Promise((resolvequerysuggest,rejectquerysuggest) => {
                      console.log('evaluating', key);
                      // let comp = formioinstance.formio.getComponent(key); // not working but just because not yet initialized
                      let comp = {component: findComponentWithKey(formconfig, key)};
                      if (comp && comp.component && comp.component.data && comp.component.data.url) {
                        //let url = API_URL + comp.component.data.url + '?limit=100&skip=0&input='+value+'&swiluonas=1';
                        let url = API_URL + comp.component.data.url + '?limit=100&skip=0&input=' + value + '&';
                        if (comp.component.filter) { // filter, we are running sequentially because of this, in case for example of address with province => city
                          // var data = this.submission.data;
                          // var data = window.formioinstance.formio.data;
                          var evaluateTemplate = function (template, data) {
                            return template.replace(/{{(.*?)}}/g, (match, expr) => {
                              let value = new Function('data', `return ${expr}`)(data);
                              return value !== undefined ? value : match;
                            });
                          }
                          try {
                            const queryString = evaluateTemplate(comp.component.filter, data);
                            // console.log(queryString); // Should log: "provincia=XYZ&swiint=1"
                            url += queryString;
                          } catch (e) {
                            console.log('error', e);
                          }
                        }

                        const formattedHeaders = comp.component.data.headers.reduce((acc, header) => {
                          acc[header.key] = header.value;
                          return acc;
                        }, {});

                        fetch(url, {
                          "headers": formattedHeaders,
                          "body": null,
                          "method": "GET"
                        }).then(response => response.json()).then((vdata) => {
                          if (vdata.length) {
                            if (queryformsuggestfieldvaluedata[key]) {
                              vdata = vdata.filter(x => {
                                return x[queryformsuggestfielddata[key]] == queryformsuggestfieldvaluedata[key];
                              });
                            }
                            data[key] = vdata[0];
                            // console.log('SET', key);
                            // console.log(data[key]);
                            // console.log(vdata[0]);
                            resolvequerysuggest(data[key] = vdata[0]);
                          } else {
                            resolvequerysuggest(null);
                          }
                        });


                      }
                    }));
                  } else {
                    data[key] = value;
                  }
                }


                // Fill used by fastsign => CRM workflow
                const paramFormdata = query.get('formdata');
                if(paramFormdata){
                  data = Object.assign(data, JSON.parse(paramFormdata));
                }


                // if(Object.keys(queryformdata).length){
                //   data = Object.assign(data, queryformdata);
                // }
                if (promises.length) {
                  // Promise.all(
                  //     promises).then(() => {
                  //   resolve(data);
                  // }); // parallel run data fetch api
                  //promises.reduce((p, fn) => p.then(fn), resolve(data)); // run sequentially to allow dependencies on filters
                  for (const promise of promises) {
                    await promise();
                  }
                  resolve(data);
                } else {
                  resolve(data);
                }
              });
            },
            isNew: function () {
                return !this.currentSubmissionId();
            },
            hasMap:function(){
              return this.submission.generaldata.geolocation;
            },
            onDebugBuilderShowHide: function(s){
                this.debugBuilderShowHide = true;
                // Bad fixes to prevent needing close dialog before builder working :|
                setTimeout(()=>{
                    this.debugBuilderShowHide = false;
                },1);
            },
            submissionChanged: function(s){
                this.loadingSubmission = true;
                window.finalReData = null;
                this.submission.data = s;
                this.submission = Object.assign({}, JSON.parse(JSON.stringify(this.submission)));
                setTimeout(()=>{
                    this.loadingSubmission = false;
                },1);
            },
            debugLoaded: function(s){
                this.loadedDebug = true;
            },
            currentSubmissionId: function () {
                return this.$router.currentRoute.params.sid;
            },
            loadSubmissionAttachments: function () {
              ApiService.get('submissions/' + this.currentSubmissionId() ,'attachments?organization_id='+this.submission.generaldata.organization_id)
                  .then(({data}) => {
                    const attachments = data.attachments;
                    // Merge attachments from submission, named allegatoX where X is a number, use preg to get all
                    for (let key of Object.keys(this.submission.data)) {
                      if (key.match(/^allegato\d+$/)) {
                        const attc = this.submission.data[key];
                        if(!attc || attc.length==0){
                          continue;
                        }
                        const att = attc[0];
                        attachments.push({
                          'DocumentId': att.fileKey,
                          'Name': att.name,
                          'fileKey': att.fileKey,
                          'name': att.name,
                        });
                      }
                    }
                    this.attachments = attachments;
                  });
            },
            getSubmissionAttachment: function (item) {
              const documentId = item.DocumentId
              const documentName = item.Name;
              if(item.fileKey){
                return customFastStorageProvider.downloadFile(item);
              }
              ApiService.getFile('submissions/' + this.currentSubmissionId()+'/attachments' ,documentId+'?organization_id='+this.submission.generaldata.organization_id)
                  .then(({data}) => {
                    window.r = data;

                    // const byteCharacters = data;
                    // const byteNumbers = new Array(byteCharacters.length);
                    // for (let i = 0; i < byteCharacters.length; i++) {
                    //   byteNumbers[i] = byteCharacters.charCodeAt(i);
                    // }
                    // const byteArray = new Uint8Array(byteNumbers);
                    var blob = new Blob([data], { type: 'application/octet-stream' });
                    if (window.navigator.msSaveBlob) { // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
                      window.navigator.msSaveOrOpenBlob(blob, documentName);
                    }
                    else {
                      var a = window.document.createElement("a");
                      a.href = window.URL.createObjectURL(blob, { type: "application/octet-stream" });
                      a.download = documentName;
                      document.body.appendChild(a);
                      a.click();  // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
                      document.body.removeChild(a);
                    }



                  });
            },
            currentDuplicateSubmissionId: function () {
                return this.$router.currentRoute.params.csid;
            },
            currentContractId: function () {
                return this.$router.currentRoute.params.id+'';
            },
            //
            // isSubmissionView: function () {
            //     return this.currentSubmissionId();
            // },


            // useDebugData: function () {
            //     return this.$router.currentRoute.query.debugdata2 && UserService.isSuperDebugUser();
            // },

            submit: function (submission, callback) {
                console.log('submission', submission);
                let that = this;
                let senddata = null;
                this.loading = true;
                if (this.config.formsubmit) {
                    (function (submission) {
                        var formresult = {data: {submission: submission}};
                        try {
                            eval(that.config.formsubmit);
                        } catch (exceval) {
                            console.log('EVAL ERROR', exceval);
                            that.$customdebugtracker.error('FORM SUBMIT EVAL ERROR', {'error': exceval, 'stack': JSON.stringify(exceval.stack), 'form': JSON.stringify(formresult), 'contractId': that.currentContractId()} );
                            Vue.customNotifyError('Errore nei dati', 'Si prega di riprovare');
                            callback('Errore nei dati inseriti, si prega di verificare il form e riprovare. Una notifica è stata inviata per analizzare l\'errore');
                            that.loading = false;
                            // formresult = 'ERRORE JS SUBMIT';
                            return;
                        }
                        that.formresult = formresult;
                    })(submission.data);
                } else {
                    that.formresult = {data: {submission: submission.data}};
                }
                senddata = that.formresult;


                if(!senddata){
                    callback('Errore nei dati inseriti, si prega di verificare il form e riprovare. Una notifica è stata inviata per analizzare l\'errore');
                    return;
                }


              // Find files, e.g. objects in senddata containing property {"storage":"FastStorageProvider"}
              const files = [];
              const findFiles = (obj) => {
                for (let ind of Object.keys(obj.data.submission)) {
                  const component = obj.data.submission[ind];
                  if (Array.isArray(component) && component.length && typeof component[0] === 'object' && component[0].storage && component[0].storage === 'FastStorageProvider') {
                    files.push(component[0]);
                  }
                }
                return null;
              };
              findFiles(senddata);
              senddata.data.files = files;
              // console.log('FILES',files);
              //

              // add original_contract_log_id and original_contract_user_id if in draft data (used by subagencies)
                if (this.isDraft && that.originalContractLogId) {
                    senddata.data.original_contract_log_id = that.originalContractLogId;
                }
                if (this.isDraft && that.originalContractUserId) {
                    senddata.data.original_contract_user_id = that.originalContractUserId;
                }

                if(that.originalDuplicatedId){
                  senddata.data.original_duplicated_id = that.originalDuplicatedId;
                }


                if (this.$refs.debug.enableDebugSend()) {
                    Vue.customNotifySuccess('Debug');
                    //this.loading=false;
                    //return;
                    senddata.dry_run = 1;
                }

// console.log('POST',senddata);
// return;
//
//                 const callbackList = this.isDraft ?
//                     ApiService.post(('drafts') + (this.isNew() ? '' : '/' + this.currentSubmissionId()), senddata) :
//                     ApiService.post(('submissions') + (this.isNew() ? '' : '/' + this.currentSubmissionId()), senddata);




                const finalSend = () => {

                  let newWindow = null;
                  if(!this.isDraft && CrmService.isFormConnectedToCrm(this.contractData.contract)){
                    newWindow = CrmService.openDestinationUrlBefore();
                  }

                  const callbackList =
                      ApiService.post(('submissions') + (this.isNew() || this.isDraft ? '' : '/' + this.currentSubmissionId()), senddata);


                  callbackList
                      .then(({data}) => {


                        if (this.isNew() || this.isDraft) {
                          callback(null);
                          Vue.customNotifySuccess('Salvato');
                          /*this.$router.push({ name: "document-submission-view", 'params':{'sid':data.id,'id':data.contract_configuration_id} }, () => {
                              this.reload();
                          });*/
                          if (that.$refs.debug.enableDebugSend()) {
                            that.$refs.debug.debugSendData(data)

                            this.loading = false;

                            if(CrmService.isFormConnectedToCrm(this.contractData.contract)) {
                              CrmService.openDestinationUrl(newWindow, this.contractData.contract, senddata, this.currentFormData, data);
                            }
                          } else {

                            if(this.isDraft){
                              ApiService.delete('drafts/'+this.currentSubmissionId(),{'id':this.currentSubmissionId()}).then(() => {
                                this.$router.push({
                                  name: "document-history",
                                  query: {'filter_contract': data.contract_configuration_id}
                                }, () => {
                                  //this.reload();
                                });
                              });
                            }else {
                              if(CrmService.isFormConnectedToCrm(this.contractData.contract)) {
                                CrmService.openDestinationUrl(newWindow, this.contractData.contract, senddata, this.currentFormData, data);
                              }

                              this.$router.push({
                                name: "document-history",
                                query: {'filter_contract': data.contract_configuration_id}
                              }, () => {
                                //this.reload();
                              });
                            }
                          }
                          // this.$router.go();
                          // this.loading = false;
                          //this.reload();
                        } else {
                          callback(null);
                          Vue.customNotifySuccess('Salvato');
                          // this.loading = false;
                          this.reload();
                        }
                        if (!that.$refs.debug.enableDebugSend()) {
                          this.config.options.readOnly = true;
                        }
                        //
                        //
                        //https://bootstrap-vue.js.org/docs/components/toast/
                        // this.$bvToast.toast(`This is toast number ${this.toastCount}`, {
                        //     title: 'BootstrapVue Toast',
                        //     autoHideDelay: 5000,
                        //     appendToast: append
                        // })

                      })
                      .catch(({response}) => {
                        let errormessage;
                        if(!response){
                          errormessage = 'Errore di connessione, si prega di riprovare';
                        }else {
                          //context.commit(SET_ERROR, response.data.errors);
                          errormessage = response.data && response.data.errors && Array.isArray(response.data.errors) ? response.data.errors.join(', ') : 'Errore, si prega di riprovare';
                        }
                        Vue.customNotifyError('Errore', errormessage);
                        callback(errormessage);
                        that.$customdebugtracker.warn('FORM SUBMIT ERROR '+errormessage, {'response': response} );
                        $('#formfinal .alert').removeClass('alert-success').addClass('alert-danger');
                        $('#formfinal .alert p').text(errormessage);
                        this.loading = false;
                      });
                }


                const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                const needsGeolocation = (this.config.extraconfigParsed && this.config.extraconfigParsed.geolocation) && isMobile;
                if(needsGeolocation){
                  this.getPositionData().then((position)=>{
                    senddata.data.geolocation = {
                      latitude: position.coords.latitude,
                      longitude: position.coords.longitude,
                      accuracy: position.coords.accuracy,
                      // altitude: position.coords.altitude,
                      // altitudeAccuracy: position.coords.altitudeAccuracy,
                      // heading: position.coords.heading,
                      // speed: position.coords.speed,
                      timestamp: position.timestamp
                    };
                    finalSend();
                  }).catch((err)=>{
                    console.log('POSITION ERROR',err);
                    senddata.data.geolocation = {
                      error: {
                        code : err.code,
                        message : err.message
                      }
                    };
                    finalSend();
                  });
                }else{
                  finalSend();
                }


            },

            saveDraft: function (submission) {
                const callback = (message) => {
                    if (message){
                        alert(message);
                    }
                };

                let that = this;
                let senddata = null;
                this.loading = true;

                senddata =  {data: {submission: this.submission.data}};

                senddata.contract_configuration_id = this.contractData.contract.id;
                senddata.contract_template_id = this.contractData.templates[0].id;
                senddata.organization_id = this.contractData.contract.organization_id;

                if(that.originalDuplicatedId){
                  senddata.data.original_duplicated_id = that.originalDuplicatedId;
                }

                if(!senddata){
                    callback('Errore nei dati inseriti, si prega di verificare il form e riprovare. Una notifica è stata inviata per analizzare l\'errore');
                    return;
                }


              // Find files, e.g. objects in senddata containing property {"storage":"FastStorageProvider"}
              const files = [];
              const findFiles = (obj) => {
                for (let ind of Object.keys(obj.data.submission)) {
                  const component = obj.data.submission[ind];
                  if (Array.isArray(component) && component.length && typeof component[0] === 'object' && component[0].storage && component[0].storage === 'FastStorageProvider') {
                    files.push(component[0]);
                  }
                }
                return null;
              };
              findFiles(senddata);
              senddata.data.files = files;
              // console.log('FILES',files);
              //


                //
                // if (this.$refs.debug.enableDebugSend()) {
                //     Vue.customNotifySuccess('Debug');
                //     //this.loading=false;
                //     //return;
                //     senddata.dry_run = 1;
                // }

// console.log('POST',senddata);
// return;
                ApiService.post(('drafts') + (this.isNew() ? '' : '/' + this.currentSubmissionId()), senddata)
                    .then(({data}) => {


                        if (this.isNew()) {
                            callback(null);
                            Vue.customNotifySuccess('Salvato');
                            /*this.$router.push({ name: "document-submission-view", 'params':{'sid':data.id,'id':data.contract_configuration_id} }, () => {
                                this.reload();
                            });*/
                            if (that.$refs.debug.enableDebugSend()) {
                                that.$refs.debug.debugSendData(data)

                                this.loading = false;
                            } else {
                                this.$router.push({
                                    name: "document-history-drafts",
                                    query: {'filter_contract': data.contract_configuration_id}
                                }, () => {
                                    //this.reload();
                                });
                            }
                            // this.$router.go();
                            // this.loading = false;
                            //this.reload();
                        } else {
                            callback(null);
                            Vue.customNotifySuccess('Salvato');


                            this.$router.push({
                                name: "document-history-drafts",
                                query: {'filter_contract': data.contract_configuration_id}
                            }, () => {
                                //this.reload();
                            });

                            // this.loading = false;
                            this.reload();
                        }
                        if (!that.$refs.debug.enableDebugSend()) {
                            this.config.options.readOnly = true;
                        }
                        //
                        //
                        //https://bootstrap-vue.js.org/docs/components/toast/
                        // this.$bvToast.toast(`This is toast number ${this.toastCount}`, {
                        //     title: 'BootstrapVue Toast',
                        //     autoHideDelay: 5000,
                        //     appendToast: append
                        // })

                    })
                    .catch(({response}) => {
                        let errormessage;
                        if(!response){
                            errormessage = 'Errore di connessione, si prega di riprovare';
                        }else {
                            //context.commit(SET_ERROR, response.data.errors);
                            errormessage = response.data && response.data.errors && Array.isArray(response.data.errors) ? response.data.errors.join(', ') : 'Errore, si prega di riprovare';
                        }
                        Vue.customNotifyError('Errore', errormessage);
                        callback(errormessage);
                        that.$customdebugtracker.warn('FORM SUBMITDRAFT ERROR '+errormessage, {'response': response} );
                        $('#formfinal .alert').removeClass('alert-success').addClass('alert-danger');
                        $('#formfinal .alert p').text(errormessage);
                        this.loading = false;
                    });
            },
            onRender: function(){
                window.formioinstance = this.$refs.formfinal;
                // window.formioinstance.formio.formio.formId = this.currentContractId();
                // window.formioinstance.formio.formio.formUrl = window.location.href;
                //console.log('on form render');
                // https://github.com/formio/formio.js/wiki/Form-Renderer#events
                $(".formio-select-autocomplete-input").each(function(){
                    if(!$(this).attr('autocomplete')) {
                        $(this).attr("autocomplete", "randomStringFormioNoAutocomplete");
                    }
                });
                if(window.finalReData) {
                  var reData = window.finalReData;
                  window.finalReData = null;
                  setTimeout(()=>{
                    this.submissionChanged(reData);
                  },10);
                }
            },
            onPrevPage: function(){
                //console.log('on form onPrevPage');
            },
            onNextPage: function(){
                //console.log('on form onNextPage');
            },
            getPositionData: function(){
              return new Promise((resolve, reject) => {
                const successCallback = (position) => {
                  resolve(position);
                };

                const errorCallback = (error) => {
                  reject(error);
                };
                navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
              });
            },
            loadMapLocations: function(){
              var bounds = new google.maps.LatLngBounds();
              var map = new google.maps.Map(document.getElementById('mapsub'), {
                zoom: 10,
                center: new google.maps.LatLng(45,11),
                mapTypeId: google.maps.MapTypeId.ROADMAP
              });

              var infowindow = new google.maps.InfoWindow();

              var marker;

              const contractPosition = this.submission.generaldata.geolocation.closest_position;
              if(contractPosition) {
                marker = new google.maps.Marker({
                  position: new google.maps.LatLng(contractPosition.latitude, contractPosition.longitude),
                  map: map,
                  icon: {
                    size: new google.maps.Size(32, 32),
                    scaledSize: new google.maps.Size(32, 32),
                    origin: new google.maps.Point(0, 0),
                    url: "data:image/svg+xml;base64,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",
                    anchor: new google.maps.Point(16, 16)
                  }
                });
                bounds.extend(marker.position);
                google.maps.event.addListener(marker, 'click', (function (marker) {
                  return function () {
                    infowindow.setContent('Utenza: ' + contractPosition.address);
                    infowindow.open(map, marker);
                  }
                })(marker));
              }

              const userPosition = this.submission.generaldata.geolocation.user_position;
              if(userPosition) {
                marker = new google.maps.Marker({
                  position: new google.maps.LatLng(userPosition.latitude, userPosition.longitude),
                  map: map,
                  icon: {
                    size: new google.maps.Size(32, 32),
                    scaledSize: new google.maps.Size(32, 32),
                    origin: new google.maps.Point(0, 0),
                    url: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBVcGxvYWRlZCB0bzogU1ZHIFJlcG8sIHd3dy5zdmdyZXBvLmNvbSwgR2VuZXJhdG9yOiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4NCjxzdmcgZmlsbD0iIzAwMDAwMCIgaGVpZ2h0PSI4MDBweCIgd2lkdGg9IjgwMHB4IiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIA0KCSB2aWV3Qm94PSIwIDAgMjg1LjAwMSAyODUuMDAxIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnPg0KCQk8cGF0aCBkPSJNMjgwLjQ5MSwxMjQuMjUyTDE1MC45NDksMTIuODQ3Yy00Ljg2MS00LjE3NS0xMi4wMzYtNC4xNzUtMTYuODk3LDBMNC41MDksMTI0LjI1Mg0KCQkJYy01LjQyNCw0LjY2Ny02LjA0MiwxMi44NDYtMS4zNzksMTguMjcxYzQuNjc2LDUuNDIxLDEyLjg1Miw2LjAzNiwxOC4yNywxLjM3NkwxNDIuNSwzOS43NTdsMTIxLjEsMTA0LjE0MQ0KCQkJYzIuNDQ5LDIuMTAzLDUuNDQ5LDMuMTI5LDguNDM2LDMuMTI5YzMuNjQ5LDAsNy4yNzMtMS41MjcsOS44MzQtNC41MDVDMjg2LjUzNCwxMzcuMDk4LDI4NS45MTUsMTI4LjkxOCwyODAuNDkxLDEyNC4yNTJ6Ii8+DQoJCTxwYXRoIGQ9Ik0xNDIuNSwxMjkuNTQzYy0xNi4wNzUsMC0yOS4xNDksMTMuMDc1LTI5LjE0OSwyOS4xNDlzMTMuMDc1LDI5LjE1MiwyOS4xNDksMjkuMTUyczI5LjE0OS0xMy4wNzgsMjkuMTQ5LTI5LjE1Mg0KCQkJUzE1OC41NzUsMTI5LjU0MywxNDIuNSwxMjkuNTQzeiIvPg0KCQk8cGF0aCBkPSJNMTQ2LjczLDU3LjkxOWMtMi40MzctMi4wOTMtNi4wMjQtMi4wOTMtOC40NjEsMGwtOTcuNjIyLDg0LjIwOGMtMS40MjMsMS4yMjgtMi4yNDUsMy4wMTgtMi4yNDUsNC45MDF2MTIxLjc4MQ0KCQkJYzAsMy41NzUsMi45LDYuNDc2LDYuNDc2LDYuNDc2aDE5NS4yNDRjMy41NzUsMCw2LjQ3Ni0yLjkwMSw2LjQ3Ni02LjQ3NlYxNDcuMDI4YzAtMS44ODMtMC44MjItMy42NzQtMi4yNDUtNC45MDFMMTQ2LjczLDU3LjkxOXoNCgkJCSBNMTQ3LjYwMywyNTEuNzQxYy0xLjIyNSwxLjU3NC0zLjEwNSwyLjQ5Ni01LjEwMywyLjQ5NnMtMy44NzgtMC45MjEtNS4xMDMtMi40OTZjLTUuMTE1LTYuNTQ3LTQ5Ljk1NS02NC43OTktNDkuOTU1LTkzLjA0OA0KCQkJYzAtMzAuMzYyLDI0LjcwMi01NS4wNTgsNTUuMDU4LTU1LjA1OHM1NS4wNTgsMjQuNjk2LDU1LjA1OCw1NS4wNThDMTk3LjU1OCwxODYuOTQyLDE1Mi43MTcsMjQ1LjE5NCwxNDcuNjAzLDI1MS43NDF6Ii8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+",
                    anchor: new google.maps.Point(16, 16)
                  }
                });
                bounds.extend(marker.position);
                google.maps.event.addListener(marker, 'click', (function (marker) {
                  return function () {
                    infowindow.setContent('Firma');
                    infowindow.open(map, marker);
                  }
                })(marker));
              }
              map.fitBounds(bounds);
            },
            fileUpload: function () {
              document.getElementById("fileUpload").click()
            },
            onFileChange(e) {
              var files = e.target.files || e.dataTransfer.files;
              if (!files.length)
                return;
              this.attachmentsLoading = true;
              let file = files[0];
              let that = this;
              var reader = new FileReader();
              reader.readAsBinaryString(file);
              reader.onload = function() {
                //console.log(btoa(reader.result));
                ApiService.post('submissions/'+that.currentSubmissionId()+'/manual-attachments', {
                  'base64': btoa(reader.result),
                  'fileName': file.name,
                  'type': file.type,
                  'size': file.size
                })
                    .then(({data}) => {
                        that.loadSubmissionAttachments();
                        that.reload();
                        Vue.customNotifySuccess('Salvato');
                        that.attachmentsLoading = false;
                        // reset form file
                        document.getElementById("fileUpload").value = "";
                        // that.reload();
                    })
                    .catch(({response}) => {
                      // console.log('error', response);
                      //context.commit(SET_ERROR, response.data.errors);
                      Vue.customNotifyError('Errore', response.data && response.data.errors ? response.data.errors.join(', ') : 'Si prega di riprovare');
                      document.getElementById("fileUpload").value = "";
                    });
              };
              reader.onerror = function () {
                //console.log('there are some problems');
                Vue.customNotifyError('Errore, Si prega di riprovare');
              };
              //this.createImage(files[0]);
            },
            onFormChange:function(e){
                this.currentFormData = e;
                if(this.$refs && this.$refs.debug && this.$refs.debug.formChange) {
                    this.$refs.debug.formChange(e);
                    setTimeout(function(){
                        $(".formio-select-autocomplete-input:not([autocomplete])").each(function(){
                            // if(!$(this).attr('autocomplete')) {
                                $(this).attr("autocomplete", "randomStringFormioNoAutocomplete");
                            // }
                        });
                    });
                }
            },
            toggleUploadBox: function() {
                this.showUploadBox = !this.showUploadBox;
                if (this.showUploadBox) {
                    // Close the box when clicking outside
                    setTimeout(() => {
                        document.addEventListener('click', this.closeUploadBox);
                    }, 0);
                } else {
                    document.removeEventListener('click', this.closeUploadBox);
                }
            },
            closeUploadBox: function() {
                this.showUploadBox = false;
                document.removeEventListener('click', this.closeUploadBox);
            },
            triggerPrefillFileUpload: function() {
                this.$refs.prefillFileInput.click();
            },
            onDragOver: function(e) {
                this.isDragOver = true;
            },
            onDragLeave: function(e) {
                this.isDragOver = false;
            },
            onDrop: function(e) {
                this.isDragOver = false;
                const files = e.dataTransfer.files;
                if (files.length > 0) {
                    this.processPrefillFile(files[0]);
                }
            },
            onPrefillFileChange: function(e) {
                const files = e.target.files;
                if (files.length > 0) {
                    this.processPrefillFile(files[0]);
                }
            },
            // extractSelectOptions: function() {
            //     return PrefillService.extractSelectOptions(this.config);
            // },
            // extractAllFormFields: function() {
            //     return PrefillService.extractAllFormFields(this.config);
            // },
            processPrefillFile: async function(file) {
                // Close the upload box immediately and show loading state
                this.showUploadBox = false;
                document.removeEventListener('click', this.closeUploadBox);

                const componentContext = {
                    submission: this.submission,
                    config: this.config,
                    uploadDocType: this.uploadDocType,
                    submissionChanged: this.submissionChanged
                };

                await PrefillService.processPrefillFile(
                    file,
                    componentContext,
                    () => {
                        // onStart
                        this.uploadingPrefill = true;
                    },
                    () => {
                        // onSuccess
                        Vue.customNotifySuccess('Campi precompilati con successo');
                        this.uploadingPrefill = false;
                        this.fillingPrefill = false;
                        // Reset file input
                        if (this.$refs.prefillFileInput) {
                            this.$refs.prefillFileInput.value = '';
                        }
                    },
                    (error) => {
                        // onError
                        Vue.customNotifyError('Errore', 'Errore durante l\'elaborazione del file');
                        this.uploadingPrefill = false;
                        this.fillingPrefill = false;
                    },
                    () => {
                        // onFillStart
                        this.uploadingPrefill = false;
                        this.fillingPrefill = true;
                    }
                );
            },
            fillFieldsWithApiSupport: async function(data) {
                const componentContext = {
                    submission: this.submission,
                    config: this.config,
                    submissionChanged: this.submissionChanged
                };

                await PrefillService.fillFieldsWithApiSupport(data, componentContext);
            },
            openTransferModal() {
                this.showTransferModal = true;
                this.loadAvailableUsers();
            },
            closeTransferModal() {
                this.selectedUserId = null;
                this.availableUsers = [];
                this.filteredUsers = [];
                this.userSearchQuery = '';
                this.showTransferModal = false;
            },
            filterUsers() {
                // This method is called on input, but filtering is done in computed property
                // We keep it for potential future use or debugging
            },
            async loadAvailableUsers() {
                this.loadingUsers = true;
                try {
                    const currentUser = this.$store.getters.currentUser;
                    const isSuperAdmin = UserService.isSuperDebugUser();

                    const { data } = await ApiService.get('users');
                    let users = data.rows;

                    // Additional filter: if user is not superadmin, only show users from same organization
                    if (!isSuperAdmin && currentUser.organization_id) {
                        users = users.filter(u => u.organization_id === currentUser.organization_id);
                    }

                    // Filter users based on permissions
                    if (currentUser.is_admin) {
                        // Admin can assign to anyone (already filtered by organization if not superadmin)
                        this.availableUsers = users.filter(u => u.id !== currentUser.id);
                    } else if (currentUser.is_organization_admin) {
                        // Organization admin can assign to users in the same organization
                        this.availableUsers = users.filter(u =>
                            u.organization_id === currentUser.organization_id &&
                            u.id !== currentUser.id
                        );
                    } else if (currentUser.groups && currentUser.groups.length > 0) {
                        // Group admin can assign to users in the same groups
                        // First, get the groups where the current user is an admin
                        const adminGroupIds = currentUser.groups
                            .filter(g => g.is_admin)
                            .map(g => g.id);

                        if (adminGroupIds.length > 0) {
                            // Filter users who belong to at least one of these groups
                            this.availableUsers = users.filter(u => {
                                if (u.id === currentUser.id) return false;
                                if (!u.groups || u.groups.length === 0) return false;

                                // Check if user belongs to any of the admin groups
                                return u.groups.some(userGroup =>
                                    adminGroupIds.includes(userGroup.id)
                                );
                            });
                        } else {
                            this.availableUsers = [];
                        }
                    } else {
                        // No permission to transfer
                        this.availableUsers = [];
                    }

                    // Set filtered users to show initially and sort alphabetically
                    this.filteredUsers = this.availableUsers.map(user => ({
                        value: user.id,
                        firstname: user.firstname,
                        lastname: user.lastname,
                        email: user.email
                    })).sort((a, b) => {
                        // Sort by lastname first, then by firstname
                        const lastNameCompare = (a.lastname || '').localeCompare(b.lastname || '');
                        if (lastNameCompare !== 0) return lastNameCompare;
                        return (a.firstname || '').localeCompare(b.firstname || '');
                    });

                    if (this.filteredUsers.length === 0) {
                        Vue.customNotifyWarning('Nessun utente disponibile per il trasferimento');
                    }
                } catch (error) {
                    console.error('Error loading users:', error);
                    Vue.customNotifyError('Errore nel caricamento degli utenti');
                    this.availableUsers = [];
                    this.filteredUsers = [];
                } finally {
                    this.loadingUsers = false;
                }
            },
            async transferDraft(bvModalEvt) {
                bvModalEvt.preventDefault();

                if (!this.selectedUserId) {
                    Vue.customNotifyWarning('Seleziona un utente');
                    return;
                }

                this.transferLoading = true;
                try {
                    const draftId = this.currentSubmissionId();
                    await ApiService.post(`drafts/assign/${draftId}`, {
                        new_user_id: this.selectedUserId
                    });

                    Vue.customNotifySuccess('Bozza trasferita con successo');
                    this.showTransferModal = false;

                    // Redirect to drafts history
                    this.$router.push('/document/history-drafts');
                } catch (error) {
                    console.error('Error transferring draft:', error);
                    const errorMessage = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Errore nel trasferimento della bozza';
                    Vue.customNotifyError(errorMessage);
                } finally {
                    this.transferLoading = false;
                }
            }
        },
    };
</script>
